import styled from 'styled-components';

const DataTableNativeMLStyled = styled('div')`
  border-radius: 12px;
  background-color: #fff;
  height: 100%;
  padding: ${(props) => (props.np ? 0 : 32)}px;
  /* border: 1px solid red; */
  /* .srcollSet + div ::-webkit-scrollbar {
    border: 1px solid red;
    height: 30px !important;
   
  } */
  .table-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    /* gap:24px; */
  }
  .table-content {
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    overflow-y: hidden;
    margin: 24px 0;
  }

  .title {
    display: flex;
    font-size: 24px;
    padding: 24px 0;
    padding-left: 24px;
    align-items: center;
    color: #212121;
    justify-content: space-between;
    .button-wrapper {
      /* margin-right: 48px; */
    }
  }
  .number-wrapper {
    display: flex;
    justify-content: flex-end;
    .number {
      font-size: 14px;
      .text {
        color: #212121;
      }
      .line {
        color: #212121;
      }
    }
  }
  /* 关于排序样式 */
  .sort-img {
    width: 9px;
    height: 18px;
    margin-left: 7px;
    cursor: pointer;
    vertical-align: text-bottom;
  }
  .visuallyHidden {
    /* border: 1px solid red; */
    /* border: 0; */
    clip: rect(0 0 0 0);
    /* height: 1px; */
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    top: 20px;
    /* width: 1px; */
  }
  .MuiTableCell-head {
    color: #212121;
  }
  .MuiPaper-rounded {
    border: none;
  }
  .MuiIconButton-root:hover {
    /* background-color: transparent; */
  }
  .MuiTableCell-root {
    border-bottom: 0;
  }
  /* .title {
    height: 60px;
    background-color: rgba(255, 255, 255, 100);
    font-size: 16px;
    text-indent: 24px;
  } */
  .table-header {
    display: table;
    /* @media screen and (max-width: 1685px) {
      width: max-content;
    }
    @media screen and (min-width: 1685px) {
      width: 100%;
    } */
    width: 100%;
    height: 48px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    /* table-layout; */
    min-width: ${(props) =>
      props.devicesMinWidth - 256 - 24 * 2 - 32 * 2 - 10}px;
    background: #f5f5f5;
    /* color: #f5f5f5; */
    .MuiTableCell-root {
      font-size: 16px;
      padding: 0 16px 0 8px;
      margin-right: 24px;

      &:last-child {
        margin-right: 24px;
      }
    }
    .MuiTableSortLabel-active {
      color: #212121;
    }

    .MuiTableCell-paddingCheckbox {
      margin-right: 24px;
      &:last-child {
        margin-right: 24px;
      }
    }
  }

  .table-container {
    display: table;
    width: 100%;
    min-width: ${(props) =>
      props.devicesMinWidth - 256 - 24 * 2 - 32 * 2 - 10}px;
    background-color: rgba(254, 254, 254, 100);
    .MuiTableRow-root {
      border-top: 1px solid rgb(239, 239, 239, 1);
      border-bottom: 1px solid rgb(239, 239, 239, 1);
      .MuiTableCell-body {
        /* font-size: 16px; */
        color: #212121;
        height: 48px;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      &:first-child {
        border-top: none;
      }
    }
    > span {
      display: -webkit-box;
      width: 100%;
      /* height: 64px; */
      word-wrap: break-word;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .MuiFormControl-root {
      margin-right: 0;

      .MuiInputBase-root {
        font-size: 14px;
      }
    }
  }

  .MuiInputBase-input {
    text-align: right !important;
  }

  .row-backgroud {
    /* height: 60px; */
    border-top: 1px solid rgb(239, 239, 239, 1);
    border-bottom: 1px solid rgb(239, 239, 239, 1);
    /* background: rgb(245, 245, 245); */
  }

  .default-operate-box {
    .operate-self {
      display: inline-block;
      cursor: pointer;
      margin-right: 16px;
    }

    .operate-self:last-of-type {
      margin-right: 0;
    }
  }

  .table-row-selected {
    background: rgba(255, 102, 0, 0.2);
  }
`;

export { DataTableNativeMLStyled };
